<script setup>
import { inject, onMounted, onUnmounted, ref, useSlots, watch } from "vue";
import mapboxgl from "mapbox-gl";

defineOptions({ inheritAttrs: false });

const lng = defineModel("lng");
const lat = defineModel("lat");

const props = defineProps({
	draggable: Boolean
});

const slots = useSlots();
const el = ref();
let marker;

watch([lng, lat], pos => marker && marker.setLngLat(pos));

onMounted(() => {
	const opts = { draggable: props.draggable };

	if (slots.default)
		opts.element = el.value;

	marker = new mapboxgl.Marker(opts).setLngLat([lng.value, lat.value]).addTo(inject("map"));

	marker.on("dragend", () => {
		const pos = marker.getLngLat();

		lng.value = pos.lng;
		lat.value = pos.lat;
	});
});
onUnmounted(() => marker.remove());
</script>

<template>
	<div>
		<div ref="el" class="vmap-marker" v-bind="$attrs">
			<slot/>
		</div>
	</div>
</template>
